import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import {
  ManageMasterMenu,
  LoaderWrapper,
  Header,
  SliderPanel,
  TimePicker,
  SearchComponent,
  CsplTable as Table,
} from "../../../components";
import { withAppLayout } from "../../../hoc";
import { MANAGE_MASTERS_MENU } from "../../../utils";
import { ManageMasterRoutes } from "../../../routes";
import { useRouterParams } from "../../../abstracts";
import {
  ManageMasterProvider,
  manageMasterStore,
  setManageMasterSelectedMenu,
  setManageMasterLocalCache,
  setManageMasterFlow,
} from "../../../contexts";
import { Formik, FieldArray } from "formik";
import {
  GetTradingPartner,
  getClearingPartnerPlans,
  UpsertClearanceTime,
  getAdvisorOrganisation,
  getAdvisorOrganisationPlans,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { ClearanceTimeCard } from "./ClearanceTimeCard";
const clearanceTypeEnum = {
  0: "Standard",
  1: "Late day",
};
const newClearanceTime = {
  clearanceType: 0,
  id: 0,
  name: "",
  processTimeHours: new Date().getHours(),
  processTimeMinutes: new Date().getMinutes(),
  time: "",
  timeZone: "",
};
const clearanceRepsonse = "clearingTimeReponses";
const clearanceTypeTime = {
  processTimeHours: "processTimeHours",
  processTimeMinutes: "processTimeMinutes",
};
export const ManageMaster = (props) => {
  const { location } = props;
  const clearingPartnerId =
    location.pathname.split("/")[2] === "clearing-partner-details" &&
    parseInt(location.pathname.split("/")[3]);
  const clearingPartnerAccountId =
    location.pathname.split("/")[2] ===
      "clearing-partner-account-plan-details" &&
    parseInt(location.pathname.split("/")[4]);
  const advisorId =
    location.pathname.split("/")[2] === "advisor-representative-details" &&
    parseInt(location.pathname.split("/")[3]);
  const advisorRepresentativeId =
    location.pathname.split("/")[2] === "advisor-representative-plan-detail" &&
    parseInt(location.pathname.split("/")[4]);
  const [add, setAdd] = useState(false);
  const { state, dispatch } = useContext(manageMasterStore);
  const [openPlans, setOpenAssociatedPlans] = useState(false);
  const [associatedPlansFilter, setAssociatedPlansFilter] = useState([]);
  const [assosiatedPlans, setAssociatedPlans] = useState([]);
  const [open, setOpen] = useState(false);
  const { isFetching } = get(state, "api", {});
  const [load, setLoad] = useState(true);
  const flow = get(state, "flow");
  const innerDetailsFlag = get(state, "innerDetailsFlag", false);
  const initialValues = {
    clearingTimeReponses: [],
  };

  useEffect(() => {
    dispatch(setManageMasterSelectedMenu(location.pathname));
    dispatch(setManageMasterFlow({ clearingPartnerId: clearingPartnerId }));
    setLoad(false);
    if (clearingPartnerId) {
      setLoad(true);
      GetTradingPartner(clearingPartnerId)
        .then((res) => {
          if (res) {
            dispatch(
              setManageMasterLocalCache({
                model: "clearingPartnerDetail",
                data: res,
              })
            );
          }
          setLoad(false);
        })
        .catch((err) => {});
    }
    if (advisorId) {
      setLoad(true);
      getAdvisorOrganisation(advisorId).then((res) => {
        if (res.isSuccessful) {
          dispatch(
            setManageMasterLocalCache({
              model: "advisors",
              data: res.advisor,
            })
          );
        }
        setLoad(false);
      });
    }
    if (clearingPartnerAccountId) {
      dispatch(
        setManageMasterFlow({
          clearingPartnerAccountId: clearingPartnerAccountId,
        })
      );
    }
    if (advisorRepresentativeId) {
      dispatch(
        setManageMasterFlow({
          advisorRepresentativeId: advisorRepresentativeId,
        })
      );
    }
    // dispatch(setManageMasterFlow(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, open]);

  useEffect(() => {
    if (clearingPartnerId && openPlans) {
      getClearingPartnerPlans(clearingPartnerId)
        .then((res) => {
          if (res) {
            setAssociatedPlansFilter(res);
          }
        })
        .catch((err) => err);
    }
    if (advisorId && openPlans) {
      getAdvisorOrganisationPlans(advisorId)
        .then((res) => {
          setAssociatedPlansFilter(
            get(res, "advisorRepresentativeAssociatedPlans", [])
          );
        })
        .catch((err) => err);
    }
  }, [openPlans]);
  useEffect(() => {
    if (!isEmpty(associatedPlansFilter)) {
      setAssociatedPlans(associatedPlansFilter);
    }
  }, [associatedPlansFilter]);
  // console.log(state, location, planId, "state");
  useEffect(() => {
    if (innerDetailsFlag) {
    }
  }, [innerDetailsFlag]);
  const setOpenClearanceTime = () => {
    setOpen(!open);
  };
  const setOpenPlans = () => {
    setOpenAssociatedPlans(!openPlans);
  };
  const onFormSubmit = () => {
    setOpen(!open);
  };
  const onSearchChange = (val) => {
    setAssociatedPlans(
      associatedPlansFilter.filter(
        (e) => e.planName.includes(val) || e.rkPlanNumber.includes(val)
      )
    );
  };

  const pageDetails = {
    "clearing-partner-details": get(state, "clearingPartnerDetail", {}),
    "clearing-partner-account-plan-details": get(
      state,
      "clearingPartnerDetail",
      {}
    ),
    "advisor-representative-details": get(state, "advisors", {}),
    "advisor-representative-plan-detail": get(state, "advisors", {}),
  };
  console.log(pageDetails[location.pathname.split("/")[2]], "isOpen", state);
  const isLoading = get(state, "isLoading", false);

  return (
    <Row sm="12" className="h-100">
      <Col className="manage-master-column manage-menu-items">
        <ManageMasterMenu
          menuList={MANAGE_MASTERS_MENU}
          selectedMenu={get(state, "selectedMenu")}
          innerDetailsFlag={innerDetailsFlag}
          details={pageDetails[location.pathname.split("/")[2]]}
          setOpen={setOpenClearanceTime}
          advisorRepresentativeId={advisorRepresentativeId}
          clearingPartnerAccountId={clearingPartnerAccountId ?? 0}
          setOpenPlans={setOpenPlans}
        />
      </Col>
      <Col className="app-outer-layout">
        <LoaderWrapper isLoading={load} className="row manage-master-wrapper">
          <ManageMasterRoutes />
        </LoaderWrapper>
      </Col>
      <SliderPanel
        isOpen={openPlans}
        size={45}
        showCancel={false}
        onClose={setOpenPlans}
        backdropClicked={setOpenPlans}
      >
        <div className="inside-content">
          <div className="d-flex justify-content-between align-baseline clearing-partner-edit-slider">
            <div>
              <p className="investment-heading">Associated Plans</p>
            </div>
            <div>
              <Button variant="secondary" onClick={setOpenPlans}>
                Close
              </Button>
            </div>
          </div>
          <SearchComponent
            placeholder="Search by plan ID, plan name"
            className="search-component-clearing-partner"
            onSearchChange={onSearchChange}
          />
          <div className="clearing-partner-added-container">
            <div className="clearing-partner-subjects">
              <div className="clearing-partner-records">
                {assosiatedPlans?.length ?? 0} Records found
              </div>
            </div>
          </div>
          <div className="clearing-partner-table">
            <div className="header-clearing-partner">
              <div className="table-header-clearing-partner">Plan Name</div>
              {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
            </div>
            <div className="header-clearing-partner">
              <div className="table-header-clearing-partner">Plan ID</div>
              {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
            </div>
          </div>
          <Table className="details-table">
            <Table.Tbody className="body-tables">
              {!isEmpty(assosiatedPlans) &&
                assosiatedPlans.map((e, i) => (
                  <Table.Tr className="data-row">
                    <div className="table-details-value">{e.planName}</div>
                    <div className="table-details-value">{e.rkPlanNumber}</div>
                  </Table.Tr>
                ))}
            </Table.Tbody>
          </Table>
        </div>
      </SliderPanel>
      <SliderPanel
        isOpen={open}
        size={45}
        showCancel={false}
        onClose={setOpenClearanceTime}
        backdropClicked={setOpenClearanceTime}
      >
        <Formik
          initialValues={
            !isEmpty(
              get(state, "clearingPartnerDetail.clearanceTimeResponses", [])
            )
              ? {
                  clearingTimeReponses: get(
                    state,
                    "clearingPartnerDetail.clearanceTimeResponses",
                    []
                  ).map((e) => ({
                    ...e,
                    processTimeHours: e.time.split(":")[0],
                    processTimeMinutes: e.time.split(":")[1],
                  })),
                }
              : initialValues
          }
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            values,
            setSubmitting,
            dirty,
            ...rest
          }) => {
            console.log(values, "vals");
            return (
              <FieldArray name={clearanceRepsonse}>
                {({ push, remove }) => {
                  //  const onAddClearanceTime = () => {

                  //   setValues({
                  //     clearanceRepsonse: [...get(values, clearanceRepsonse), {

                  //     }]
                  //   })
                  // }
                  return (
                    <Form
                      autoComplete="off"
                      className="h-100"
                      onSubmit={handleSubmit}
                      validated={!isEmpty(rest.errors)}
                    >
                      <div className="inside-content">
                        <div className="d-flex justify-content-between align-baseline clearing-partner-edit-slider">
                          <div>
                            <p className="investment-heading">
                              Manage Clearance Time
                            </p>
                          </div>
                          <div>
                            <Button
                              variant="secondary"
                              onClick={setOpenClearanceTime}
                            >
                              Cancel
                            </Button>
                            {dirty ? (
                              <Button
                                variant="primary"
                                onClick={onFormSubmit}
                                className="ml-4"
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                variant="primary"
                                onClick={() => push(newClearanceTime)}
                                className="ml-4"
                              >
                                Add
                              </Button>
                            )}
                          </div>
                        </div>
                        <div className="clearing-partner-added-container">
                          <div className="clearing-partner-subjects">
                            <div className="clearing-partner-recently-added">
                              Recently Added/Modified
                            </div>
                            <div className="clearing-partner-records">
                              {get(values, "clearingTimeReponses", {})
                                ?.length ?? 0}{" "}
                              Records found
                            </div>
                          </div>
                        </div>

                        <div className="clearing-partner-table">
                          <div className="header-clearing-partner w-10">
                            <div className="table-header-clearing-partner">
                              {`Time (EST)`}
                            </div>
                          </div>
                          <div className="header-clearing-partner w-40">
                            <div className="table-header-clearing-partner">
                              Clearance Time Name
                            </div>
                          </div>
                          <div className="header-clearing-partner w-30">
                            <div className="table-header-clearing-partner">
                              Clearance Type
                            </div>
                          </div>
                          <div className="header-clearing-partner w-20">
                            <div className="table-header-clearing-partner">
                              Actions
                            </div>
                          </div>
                        </div>

                        <div className="clearance-time-detail-tiles">
                          {get(values, "clearingTimeReponses", [])?.map(
                            (e, i) => (
                              <ClearanceTimeCard
                                val={e}
                                remove={remove}
                                index={i}
                                dispatch={dispatch}
                                clearingPartnerId={clearingPartnerId}
                                values={values}
                                clearanceRepsonse={clearanceRepsonse}
                                clearanceTypeEnum={clearanceTypeEnum}
                                dirty={dirty}
                                setFieldValue={setFieldValue}
                                handleChange={handleChange}
                                clearanceTypeTime={clearanceTypeTime}
                              />
                            )
                          )}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </FieldArray>
            );
          }}
        </Formik>
      </SliderPanel>
    </Row>
  );
};

const ManageMasterWithProvider = (props) => {
  return (
    <ManageMasterProvider>
      <ManageMaster {...props} />
    </ManageMasterProvider>
  );
};

export default withAppLayout(ManageMasterWithProvider);
